$(document).ready(function() {
    console.log( "country check" );
  if(window.location.href !== "https://www.turkishcarpetusa.com/pages/work-in-progress") {
      $.ajax({
          url: "https://api.country.is/",
          contentType: "application/json",
          dataType: 'json',
          success: function(result){
            if(result.country === "TR" || result.country === "IN") {
              window.location.replace("https://www.turkishcarpetusa.com/pages/work-in-progress");
            }
              console.log(result.country);
          }
      })
  }
});
// Sticky header
$(window).scroll(function(){
    if ($(window).scrollTop() >= 566) {
        $('header').addClass('tcarpets_header_sticky');
        $('.site-header__mobile-nav').addClass('animated pulse');
    }
    else {
        $('header').removeClass('tcarpets_header_sticky');
        $('.site-header__mobile-nav').removeClass('animated pulse');
    }
});
$("button.mobile-nav--open").click(function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
}); 
$("#ContactFormPhone").inputmask({"mask": "(999) 999-9999"});
//start equal heights script
 equalheightimage = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
}
equalheightname = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
}

$( window ).load(function() {
  equalheightimage('.equalheight-image');
  equalheightname('.equalheight-name');
});


$( window ).resize(function(){
  equalheightimage('.equalheight-image');
  equalheightname('.equalheight-name');
});
//start find my rugs
$('body').on('click', 'a#tk-find-rugs', function () {  
  window.location = '/collections/all?_=pf&'+ jQuery('#ContactFormSupportStyle').val() +'&'+ jQuery('#ContactFormSupportSize').val() +'&'+ jQuery('#ContactFormSupportColor').val()      
});

